export default __webpack_public_path__ + "static/media/succession_planning_overview.be303169.svg";